import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import useHttp from "../../hooks/use-http";

let featureRequestSchema = yup.object().shape({
  title: yup
    .string()
    .required("Please enter topic")
    .max(50, "Topic should have maximum of 50 characters"),
  message: yup
    .string()
    .required("Please enter message")
    .max(300, "Message should have maximum of 256 characters"),
});

const FeatureRequestForm = (props: {
  featureRequestFor: string;
  requestFormOpenState: boolean;
  setRequestFormOpenState: (_0: boolean) => void;
}) => {

  const { isLoading, isError, message, sendRequest: submitFormData } = useHttp();

  const {
    register: featureRequestForm,

    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(featureRequestSchema),
  });

  const { featureRequestFor, requestFormOpenState, setRequestFormOpenState } = props;
  const [submitState, setSubmitState] = React.useState(false);



  const submitFormDataResponse = (res: any) => {
    console.log(res)
    if (res.error === false) {
      // setSignupStatus(true);
      setSubmitState(true);

        setTimeout(() => {
          setRequestFormOpenState(false);
          setSubmitState(false)
        }, 3000);        
      // console.log(signUpAuthData)
      // authCxt.login(signUpAuthData);
      // navigate("/");
    }
  };


  const onSubmit = (data: any) => {

  

    submitFormData(
      {
        URL: "/api/send-mail",
        method: "POST",
        header: {
          "Content-Type": "application/json",
        },
        body: {
          title: data.title, // "Kumar",
          message: data.message, //"Natarajan",
          supportFor: featureRequestFor || "Feature Request"
        },
      },
      submitFormDataResponse
    );


  };

  const handleClose = () => {
    setRequestFormOpenState(false);
  };

  return (
    <div>
      <Dialog open={requestFormOpenState} onClose={handleClose}>
        {submitState === false ? (
          <DialogTitle>Feature Request</DialogTitle>
        ) : (
          ""
        )}
        <DialogContent>
          {submitState === false ? (
            <>
              <DialogContentText>
                Missing some features or you'd like to modify existing ones?
                We'd love to hear your suggestions. Raise a request with us and
                we'll have it reviewed and addressed for you
              </DialogContentText>
              <Box
                mt={3}
                component="form"
                noValidate
                onSubmit={handleSubmit(onSubmit)}
              >
                <Typography variant="subtitle2" mt={2} mb={1}>
                Topic
                </Typography>
                <TextField
                  error={Boolean(errors.title)}
                  helperText={errors.title ? errors.title.message : " "}
                  required
                  {...featureRequestForm("title")}
                  fullWidth
                  placeholder="Ex: Mini-charts enhancement"
                  size="small"
                  id="email"
                  autoComplete="email"
                  autoFocus
                  sx={{ mb: 0 }}
                />

                <Typography variant="subtitle2" mb={1}>
                Your message
                </Typography>

                <TextField
                  error={Boolean(errors.message)}
                  helperText={errors.message ? errors.message.message : " "}
                  fullWidth
                  {...featureRequestForm("message")}
                  id="filled-textarea"
                  // label="Multiline Placeholder"
                  placeholder="Please explain your feature request in detail"
                  multiline
                  variant="filled"
                  maxRows={5}
                  // pl={1}
                  sx={{ fontSize: "6px" }}
                />

                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={isLoading}
                    sx={{
                      mt: 3,
                      mb: 2,
                      width: "250px",
                      bgcolor: "#F47907",
                      fontSize: "11px",
                      "&.Mui-disabled": {
                        background: "#f6d9b9",
                      },
                      "&:hover": {
                        bgcolor: "#FF8D24",
                      },
                    }}
                  >
                    Submit
                  </LoadingButton>
                </Box>
              </Box>
            </>
          ) : (
            <Grid sx={{ width: "100%", textAlign: "center" }}>
              
              <Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <LoadingButton
                    // loading={isLeading}

                    variant="text"
                    sx={{
                      mt: 3,
                      mb: 2,
                      width: "100px",

                      height: "100px",
                    }}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ color: "#5ACE65", fontSize: "60px" }}
                    />
                  </LoadingButton>
                </Box>

                <Typography
                  component="h5"
                  variant="h5"
                  sx={{ fontSize: "30px" }}
                >
                  {"Thank you for reaching out!"}
                </Typography>
                <Typography
                  variant="body2"
                  mb={2}
                  mt={1}
                  sx={{ color: "gray", fontSize: "16px" }}
                >
                  {
                    "We are grateful for your interest. Our team is currently reviewing your inquiry, and we will respond to you shortly with the information you requested."
                  }
                </Typography>
              </Box>
            </Grid>
          )}
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose}>Subscribe</Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
};

export default FeatureRequestForm;
